import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Snackbar,
  Alert,
  Divider,
  Grid,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import { DOMAINS, useDomain } from '../../../contexts/DomainContext';
import { useTheme } from '@mui/material';
import { useGraphQL } from "../../../apollo/useGraphQL";
import { useGridUtils } from "../../../utils/grid/useGridUtils";
import { useKPIProductionResult } from '../../ProductionManagement/KPIProductionResult/hooks/useKPIProductionResult';
import {
  PRODUCTION_RESULTS_MOBILE,
  PRODUCT_OPTIONS,
  EQUIPMENT_OPTIONS,
  WAREHOUSE_OPTIONS,
  START_PRODUCTION_MOBILE,
  UPDATE_PRODUCTION_RESULT_MOBILE,
  DELETE_PRODUCTION_RESULTS
} from './ProductionResultGraphQL';
import { SEARCH_CONDITIONS } from './ProductionResultConstants';
import ProductionResultList from './components/ProductionResultList';
import ProductionResultFilterDialog from './components/ProductionResultFilterDialog';
import ProductionResultForm from './components/ProductionResultForm';
import DefectInfoForm from './components/DefectInfoForm';
import { useForm } from 'react-hook-form';
import {
FORM_DEFAULT_VALUES
} from '../../ProductionManagement/KPIProductionResult/constants';


const MobileProductionResult = () => {
  // Theme 및 Context 관련
  const theme = useTheme();
  const { domain } = useDomain();
  const isDarkMode = theme.palette.mode === 'dark';
  const { executeQuery, executeMutation } = useGraphQL();
  const { generateId } = useGridUtils();

  // 스타일 관련 함수
  const getAccentColor = () => {
    if (domain === DOMAINS.PEMS) {
      return isDarkMode ? '#e67e22' : '#d35400';
    }
    return isDarkMode ? '#1976d2' : '#0a2351';
  };

  // 상태 관리
  const [selectedResult, setSelectedResult] = useState(null);

  // react-hook-form 설정
  const {
    control,
    handleSubmit,
    reset,
    watch,
    getValues,
  } = useForm({
    defaultValues: FORM_DEFAULT_VALUES
  });

  // 검색 이벤트 핸들러
  const onSearch = (data) => {
    // 검색 실행
    handleSearch(data);
  };

  // 커스텀 훅 사용
    const {
      // KPI 설비 관련
      isLoading,
      kpiEquipments,
      errorMessage,
      handleSearch,
      handleSaveEquipmentResult,

      // 색상 및 테마
      getTextColor,
      getBgColor,
      getBorderColor,

      // 옵션 데이터
      productOptions,
      warehouseOptions,
      unitOptions,
      vendorOptions,
      kpiSubscriptions, // KPI 구독 정보 추가

      // 리프레시 키
      refreshKey
    } = useKPIProductionResult();

    console.dir(isLoading);

  return (
    <Box sx={{ width: '100%',
               height: '100%',
               }}
    >
      {/* 로딩 표시 */}
      {isLoading && (
        <Box className="loading-indicator-container">
          <CircularProgress />
        </Box>
      )}

      { !isLoading && (
      <ProductionResultForm //실적 등록 및 수정 화면
          initialData={selectedResult}
          productOptions={productOptions}
          equipmentOptions={kpiEquipments}
          warehouseOptions={warehouseOptions}
          vendorOptions={vendorOptions}
          unitOptions={unitOptions}
          kpiSubscriptions={kpiSubscriptions} // KPI 구독 정보 전달
          onSave={handleSaveEquipmentResult}
          getBorderColor={getBorderColor}
          theme={theme}
          isDarkMode={isDarkMode}
          getTextColor={getTextColor}
          getBgColor={getBgColor}
      />
      )}
      {/* 오류 메시지 표시 */}
      {errorMessage && (
        <Alert
          severity="error"
          className="error-alert"
          action={
            <Button
              color="inherit"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={handleSubmit(onSearch)}
            >
              다시 시도
            </Button>
          }
        >
          {errorMessage}
        </Alert>
      )}
    </Box>
  );
};

export default MobileProductionResult;